import React, { useState, useEffect } from "react";
import "../../../css/WeekLineRental.css";
import WeekTransRental from "./WeekTransRental";
import Weather from "../../weather/WeatherView";

const WeekLineRental = () => {
  const [page, setPage] = useState(1);

  const handlePage = (item: number) => {
    setPage(item + page);
  };

  return (
    <div className="per_week_rental_line_container">
      <WeekTransRental handlePage={handlePage} page={page} />
      <Weather page={page} />
    </div>
  );
};

export default WeekLineRental;
